import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme as themeConfig } from "@themes";

export const GeneralStyle = styled.div`
  width: auto;
  height: 100%;
  margin: 5px 1%;
  .MuiFormControlLabel-root {
    margin: 0;
  }
  .MuiTableCell-head {
    width: 13px !important;
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
  .MuiTextField-root {
    margin-right: 1em;
  }
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.button.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.text.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MuiPaper-rounded {
    border-radius: 0px;
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
    padding: 5px 16px;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }

  .MuiTableCell-root {
    padding: 12px;
  }

  .MuiTableCell-alignLeft {
    text-align: -webkit-center;
  }
`;
export const Convention = styled.div`
  display: flex;
  width: 70em;
  height: auto;
  padding-top: 1em;
  margin-left: 1em;
  align-items: center;
  p {
    margin: 0 1em 0 0.4em;
  }
`;

export const ContentLoader = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
`;

export const ActionTooltipContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  align-items: center;
  column-gap: 10px;
  .tooltip-btn {
    width: 45px;
    height: 13px;
    background: ${({ theme }) => theme.button.primary};
    padding: 13px 40px;
    font-size: 14px;
    color: ${({ theme }) => theme.neutral.white};
    margin: 10px;
  }
  .disabled-btn {
    background: ${({ theme }) => theme.neutral.gray[700]};
  }
  label {
    font-size: 11px;
    font-weight: 400;
    line-height: 15px;
  }
  .MuiSwitch-sizeSmall {
    left: 30%;
  }
`;
export const ActionContainer = styled.div`
  display: flex;
`;

export const ACTIVATEBUTTON = styled.button`
  width: 74px;
  height: 27px;
  background: ${({ theme }) => theme.button.primary};
  padding: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.neutral.white};
  margin: 10px;
  border-radius: 5px;
  outline: none;
  border: none;
  &:disabled {
    background: ${({ theme }) => theme.neutral.gray[700]};
  }
`;

export const Hr = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.border.light};
  margin: 1rem 0 0rem 0;
`;

export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: themeConfig.button.primary,
    },
    "&:disabled svg": {
      color: themeConfig.neutral.gray[500],
    },
  },
  delete: {
    color: themeConfig.status.error,
  },
  buttonActive: () => ({
    background: themeConfig.button.primary,
    color: themeConfig.neutral.white,
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  }),
  buttonReview: {
    background: themeConfig.button.primary,
    color: themeConfig.neutral.white,
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  },
}));

export const ContentCenterHorizontal = styled.div`
  display: flex;
  align-items: center;
`;
